<div>
  <div [hidden]="!filterable" class="cpo-toolbar">
    @if (titles.length > 0) {
      <div style="display: flex; justify-content: space-between; align-items: center; gap: 30px;">
        @for (title of titles; track title) {
          <button
          class="cpo-multiple-table-selector"
          [class.selected]="selectedTableTitle === title"
          style="width: 100px; text-align: left;"
          (click)="selectTableTitle(title)"
          >{{ title }}</button>
        }
      </div>
    } @else {
      @if (leftToolbarButtonText) {
        <button class="cancel" style="width: fit-content;" (click)="leftToolbarButtonClicked()">{{ leftToolbarButtonText }}</button>
      }
      <h1 class="cpo-table-title cpo-toolbar__title">{{ title }}</h1>
    }
    <div class="cpo-toolbar__actions">
      <!-- <select
        [hidden]="!tableViewFilters"
        [(ngModel)]="selectedRecordType"
        style="height: 30px; border: 1px solid #dddddd"
        (change)="ddlRecordType_changed()"
      >
        <option value="">All</option>
        <option value="customers">Customers</option>
        <option value="merchants">Merchants</option>
        <option value="transactions">Transactions</option>
        <option value="users">Users</option>
      </select> -->
      <div class="search-input-wrap" [style.width]="searchBarSize">
        <app-icon
          class="search-input-icon"
          [type]="IconType.Search"
          [size]="18"
          [color]="'var(--border-color)'"
        ></app-icon>
        <input
          class="search-input"
          type="text"
          placeholder="Search"
          [(ngModel)]="searchString"
          (keyup)="txtFilter_keyup($event)"
        />
      </div>
      @if (toolbarButtonText) {
        <button class="btn-core toolbar-button" (click)="toolbarButtonClicked()">{{ toolbarButtonText }}</button>
      }
    </div>

    <!-- <div [hidden]="!tableViewFilters" style="padding-top: 15px">
      <div [hidden]="filtersVisible || recordCount < 1">
        <input
          type="button"
          value="Filter results"
          (click)="btnShowFilters_click()"
        />
      </div>

      <div
        [hidden]="!filtersVisible"
        class="sectionContainer paddedContent containerMargins"
      >
        <div [id]="'filter-container' + myId"></div>
        <p>
          <input
            type="button"
            value="Apply Filters"
            (click)="btnApplyFilters_click()"
          />&nbsp;&nbsp;&nbsp;&nbsp;
          <input
            type="button"
            value="Cancel"
            (click)="btnHideFilters_click()"
          />
        </p>
      </div>
    </div> -->
  </div>

  <div>
    <div [id]="'table-container' + myId" class="filterabletable"></div>
    <div [hidden]="this.recordCount == 0" class="cpo-table-footer__paginator" [class.cpo-table-footer__paginator--centered]="this.recordCount <= 5" style="border: 1px solid var(--gray-200); border-top: none; padding: 20px;">
      @if (this.recordCount > 5) {
        <span class="cpo-table-footer__paginator-info">
          showing {{pageStart}} - {{pageEnd}} of {{this.recordCount}} items
        </span>
        <div class="cpo-table-footer__paginator-per-page">
          <span>Per page</span>
          <span class="cpo-table-footer__paginator-divider">|</span>
          <select [(ngModel)]="pageSize" [ngModelOptions]="{standalone: true}" (change)="currentPage = 0; updatePagedData()">
            <option [value]="5">5</option>
            <option [value]="10">10</option>
            <option [value]="20">20</option>
          </select>
        </div>
        <div class="cpo-table-footer__paginator-nav">
          <button class="cpo-table-footer__nav-btn" (click)="prevPage()" [disabled]="currentPage === 0">Previous</button>
          <button class="cpo-table-footer__nav-btn" (click)="nextPage()" [disabled]="pageEnd >= this.recordCount">Next</button>
        </div>
      } @else {
        <span>showing {{pageStart}} - {{pageEnd}} of {{this.recordCount}} items</span>
      }
    </div>


    <!-- <mat-paginator
      #paginator
      [class]="'paginator'"
      [length]="this.recordCount"
      [pageIndex]="this.currentPage"
      [pageSize]="this.pageSize"
      [pageSizeOptions]="[5, 10, 25, 50]"
      (page)="handleDataPageEvent($event)"
      [hidden]="!paginated || this.recordCount <= pageSize"
    >
    </mat-paginator> -->
  </div>

  <div
    class="sectionContainer paddedContent"
    [hidden]="!hasBeenSearched || recordCount > 0 || loading"
  >
    {{ emptyMessage }}
  </div>
</div>
